import { render, staticRenderFns } from "./ModificaMultiplaDistintaBase.vue?vue&type=template&id=76f1f2e8&scoped=true&"
import script from "./ModificaMultiplaDistintaBase.vue?vue&type=script&lang=js&"
export * from "./ModificaMultiplaDistintaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1f2e8",
  null
  
)

export default component.exports